import { HttpParams } from '@angular/common/http';
import { Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { tap, map,catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

import { BaseService } from './base-service';
import { ResponsePageable } from './responsePageable';
import { FiscalYear } from 'app/core/entities/fiscalYear';

export abstract class BaseCrudService<T> extends BaseService {

    extraQueryCondition: any;
    extraSearchFields: any ;

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance BaseCrudService');
       //console.log(this.httpClient);
    }

    abstract buildSentence(entity?: T, event?: LazyLoadEvent): HttpParams;
    protected addLogicToSearch(value: T) {};
    protected addLogicToGetOne(value: T) {};

    search(entity?: T, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<ResponsePageable<T>> {

        const url = this.rutaServidor + this.uri;
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<T>>(url, { params: this.buildSentence(entity, event) })
            .pipe(
                tap(response => {
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    }
                   //console.log(response);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

    insert(entity: T): Observable<T> {
        const url = this.rutaServidor + this.uri;
        this.spinnerService.showAll();
        return this.httpClient.post<T>(url, entity)
            .pipe(
                tap(response => {
                    // debugger;
                    this.convertToDate(response);
                    this.spinnerService.hideAll(); 
                })
                ,
                catchError(e=>{  
                    this.spinnerService.hideAll();
                    let newEntity : T
                    this.notificationService.smallBoxError(e.error.messages[0]); 
                     return Observable.throw(newEntity);
                  })
            );
    }

    update(key: string | number, entity: T): Observable<T> {
        // debugger;
        const url = this.rutaServidor + this.uri + key;
        ////console.log('url ==> ' , url);
        ////console.log('entity ==> ', entity);
        this.spinnerService.showAll();
        return this.httpClient.put<T>(url, entity)
            .pipe(
                tap(response => {
                    // debugger;
                    this.convertToDate(response);
                    this.spinnerService.hideAll(); 
                })
                ,
                catchError(e=>{  
                    this.spinnerService.hideAll();
                    let newEntity : T
                    this.notificationService.smallBoxError(e.error.messages[0]); 
                     return Observable.throw(newEntity);
                  })
            );
    }

    partialUpdate(key: string | number, entity: any): Observable<T> {
        // debugger;
        const url = this.rutaServidor + this.uri + key;
        this.spinnerService.showAll();
        return this.httpClient.patch<T>(url, entity)
            .pipe(
                tap(response => {
                    // debugger;
                    this.convertToDate(response);
                    this.spinnerService.hideAll();
                   //console.log(response)
                })
            );
    }

    delete(key: string | number): Observable<any> {
        // debugger;
        const url = this.rutaServidor + this.uri + key;
        this.spinnerService.showAll();
       //console.log(url);
        return this.httpClient.delete(url)
            .pipe(
                tap(response => {
                    this.spinnerService.hideAll(); 
                })
                ,
                catchError(e=>{  
                    this.spinnerService.hideAll();
                    let newEntity : T
                    this.notificationService.smallBoxError(e.error.messages[0]); 
                     return Observable.throw(newEntity);
                  })
            );
    }

    getOneById(id: string | number): Observable<T> {
        // debugger;
        const url = this.rutaServidor + this.uri + id;
        this.spinnerService.showAll();
        return this.httpClient.get<T>(url)
            .pipe(
                tap((response: ResponsePageable<T>) => {
                   //console.log(response);
                    if (response.numberOfElements > 0) {
                        this.convertToDate(response.content[0]);
                    }
                    this.spinnerService.hideAll();
                }),
                map((response: ResponsePageable<T>) => response.content[0])
            );
    }

    getOneByCode(code: string | number): Observable<T> {
        // debugger;
        const url = this.rutaServidor + this.uri + 'code/' + code;
        this.spinnerService.showAll();
        return this.httpClient.get<T>(url)
            .pipe(
                tap((response: ResponsePageable<T>) => {
                   //console.log(response);
                    // this.addFormat(response);
                    if (response.numberOfElements > 0) {
                        this.convertToDate(response.content[0]);
                    }
                    this.spinnerService.hideAll();
                }),
                map((response: ResponsePageable<T>) => response.content[0],
                this.spinnerService.hideAll())
            );
    }

    searchByCode(entity?: T, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<T> {

        const url = this.rutaServidor + this.uri;
        this.spinnerService.showAll();
        return this.httpClient.get<T>(url, { params: this.buildSentence(entity, event) })
            .pipe(
                tap((response: ResponsePageable<T>) => {
                     if (response.numberOfElements > 0) {
                         this.convertToDate(response.content[0]);
                     }
                     this.spinnerService.hideAll();
                 }),
                 map((response: ResponsePageable<T>) => response.content[0],
                 this.spinnerService.hideAll())
            );
    }

    getListByCode(entity?: T, event?: LazyLoadEvent): Observable<T[]> {
        // debugger;
        const url = this.rutaServidor + this.uri;
        this.spinnerService.showAll();
        return this.httpClient.get<T>(url, { params: this.buildSentence(entity, null) })
            .pipe(
                tap((response: ResponsePageable<T>) => {
                   //console.log(response);
                    // this.addFormat(response);
                    if (response.numberOfElements > 0) {
                        this.convertToDate(response.content);
                    }
                    this.spinnerService.hideAll();
                }),
                map((response: ResponsePageable<T>) => response.content,
                this.spinnerService.hideAll())
            );
    }

    searchTest(entity?: T, event?: LazyLoadEvent, extraQueryCondition?: string): Observable<ResponsePageable<T>> {
        debugger;
        const url = this.rutaServidor + this.uri;
        this.spinnerService.showAll();
        return this.httpClient.get<ResponsePageable<T>>(url, { params: this.buildSentence(entity, event) })
            .pipe(
                tap(response => {
                    debugger;
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                            // debugger;
                            this.addLogicToSearch(value);
                            this.convertToDate(value);
                        })
                    }
                   //console.log(response);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/base-crud-service.ts